import React from "react";
import PropTypes from "prop-types";
import BreadcrumbBar from "widgets/BreadcrumbBar"; // TODO: Import this from Rhombus when it's ready

export default function Breadcrumb({ currentStep = 0 }){
	let stepNames = [
		"Name & Formats",
		"Add Content",
	];

	return (
		<BreadcrumbBar
			stepNames = {stepNames}
			currentStep = {currentStep}
		/>
	);
}

Breadcrumb.displayName = "SocialBreadcrumb";
Breadcrumb.propTypes = {
	currentStep: PropTypes.number,
	numSelected: PropTypes.number,
};
